import React, {FC, useEffect, useMemo, useState} from 'react';
import BTable2 from "../../../components/b-table2";
import {centerTruncate, formatTimestamp, getFiat, getFixed, getTimeLang, serializeQuery, toNumber, toXDCNumber} from "../../../common/utils/function";
import {Link, useParams} from "react-router-dom";
import axios from "axios";
import useCommon from "../../../common/hooks/useCommon";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

// import RewardChart from '../../resources/analytics/reward-chart';

interface RewardListProps {

}

const RewardList: FC<RewardListProps> = (props) => {
    const {getTime, getXDC, get0x} = useCommon();
    const {address} = useParams();
    const [isUTC, setIsUTC] = useState(false);
    const [isValue, setIsValue] =useState(false);
    const _stats = useSelector((e: Object) => (e as any)?.common?.stats);
    const {t} = useTranslation();

    const [transactionList, setTransactionList] = useState<any>([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState<any>({
        page: 1,
        limit: 50,
    });
    const [totalRecords, setTotalRecords] = useState<any>(0);

    const handle = {
        pagination: (payload: any) => {
            setPagination(payload);
        },
    };

    const handleButtonClick = () => {
        setIsUTC(!isUTC);
    };

    const getTransactions = async () => {
        try {
            setLoading(true);
            axios.get(`https://xdc.network/api/rewards/${get0x(address)}${serializeQuery({...pagination})}`).then(response => {
                setTransactionList(response?.data?.items);
                setTotalRecords(response?.data?.total);
                setLoading(false);
            }).catch((e) => setLoading(false));
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        getTransactions();
    }, [pagination, isUTC, isValue,  _stats])

    const formatFiat = (
        rewards: string | number | null | undefined,
        coinPrice: { coin_price: number | string | null | undefined }
    ): string => {
            const xdcValue = parseFloat(String(rewards));
            const exchange = parseFloat(String(coinPrice));
            const amount = xdcValue * exchange;
        return getFiat(amount || "0.00");
    };

    // Epoch	MasterNode	MasterNode Name	Sign number	Reward	Reason	Age
    const header = useMemo(() => {
        return [
            {
                title: 'Epoch',
                param: 'epoch',
                // render: (data: any) => <Link to={`/block/${data?.epoch}`}>{data?.epoch}</Link>
            },
            {
                title: 'Coinbase',
                param: 'validator',
                tooltip: (data: any) => <Link to={`/address/${get0x(data?.validator)}`}>{get0x(data?.validator)}</Link>,
                render: (data: any) => <Link to={`/address/${get0x(data?.validator)}`}>{centerTruncate(get0x(data?.validator))}</Link>
            },
            {
                title: 'MasterNode',
                param: 'holders',
                tooltip: (data: any) => <Link to={`/address/${get0x(data?.validator)}`}>{get0x(data?.validator)}</Link>,
                render: (data: any) => <Link to={`/address/${get0x(data?.validator)}`}>{data?.address}</Link>
            },
            {
                title: 'Sign number',
                param: 'signNumber',
                tooltip: true,
            },

            {
                title: (<a href="javascript:" onClick={() => setIsValue(!isValue)}data-bs-trigger="hover"> {isValue ? t("Value (USD)") : t("Amount")}</a>),
                param: "value",
                headerStyle: { minWidth: "130px" },
                  
                tooltip: true,
                render: (data: any) =>
                <span onClick={() => setIsValue(!isValue)}>
                        
                        {isValue ? formatFiat(data?.reward, _stats?.coin_price) : getFixed(data?.reward,2)}
                    </span>
            },
            // {
            //     title: 'Reason',
            //     param: 'reason',
            //     tooltip: true,
            //     render: (data: any) => "MasterNode"
            // },
            {
                title: (<a href="javascript:" onClick={handleButtonClick} data-bs-trigger="hover">{isUTC ? t("Date Time (UTC)") : t("Age")}</a>),
                param: 'age',
                tooltip: (data: any) => isUTC ? getTimeLang(data?.updatedAt, t) : formatTimestamp(data?.updatedAt),
                render: (data: any) => isUTC ? formatTimestamp(data?.updatedAt) : getTimeLang(data?.updatedAt, t),
            }
        ]
    }, [pagination, isUTC, isValue,  _stats])
    return (<React.Fragment>
        {/* <div className="py-3 mb-2">
                <RewardChart/>
            </div> */}
        <BTable2
            title={<React.Fragment>
                <p className="mb-0 font-b">
                    Total {totalRecords || 0} rewards found <br/>
                    <span className="ms-1 text-muted">
                        (Showing the last 10,000 records) </span>
                </p>
            </React.Fragment>}
            header={header}
            list={transactionList}
            loading={loading}
            pagination={pagination}
            totalRecords={totalRecords}
            onPagination={handle.pagination}
        />
    </React.Fragment>)
}

export default RewardList;
